module.exports = __webpack_public_path__ + "static/media/map-marker.9469f4b1.svg";